/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { checkViewPermission, checkComponentPermission, checkCRUDPermission, storageSetItem, idNamingConversion } from '../../../../../helpers/utilities';
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import usePrevious from "../../../../Shared/components/Previous";
import { TopBar } from "./TopBar";
import { CustomTable } from "./CustomTable";
import { PosForm } from "./PosForm";
import { StoreSalesHead } from "../../../../../config/constant";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import moment from 'moment';
import userAction from "../../../../Admin/Home/redux/actions";
import posAction from "../../../Setup/redux/actions";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import { emptyValidation } from "../../../../../helpers/validation";
import crudActions from "../../../../CRUD/redux/actions";
import posActions from "../../../Setup/redux/actions";
import { toast } from 'react-toastify';
import { useEventListener } from "../../../../../helpers/useEventListener"
import actions from "../../redux/actions";
import { isOnline } from "../../../../../helpers/axiosClient";
import { isDesktop } from "../../../../../setup/desktopApi";


const StoreSales = (props) => {
    const { posSetup } = useSelector(state => state.salesSetupReducer);
    const { posSetupUsers } = useSelector(state => state.salesSetupReducer);
    const { createDetails, createError, createLoader } = useSelector(state => state.crudReducer);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;
    const { getList, getData } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const [skip, setSkip] = useState(0);
    const [search, setSearch] = useState('');
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [form, setForm] = useState({ type: 'Sale' });
    const [error, setError] = useState({});
    const [sortBy, setSortBy] = useState("id");
    const [dateValue, setDateValue] = useState([null, null]);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [teamList, setTeamList] = useState([]);
    //const [importVisible, setImportVisible] = useState(false);
    const [newSalesModal, setNewSalesModal] = useState(false);
    const [online, setOnline] = useState(isOnline());
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);

    // Track connectivity so the sign-in can skip the online password check while
    // offline (desktop only — the web build is always "online").
    useEffect(() => {
        if (!isDesktop() || !(window.electron && window.electron.sync)) return undefined;
        const unsub = window.electron.sync.onStatus((s) => {
            if (s && typeof s.online === 'boolean') setOnline(s.online);
        });
        return unsub;
    }, []);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Store Sales', history, 'Sales')) {
                dispatch({
                    type: userAction.TEAM_DETAILS_START, url: 'team', skip: 0, filter: {
                        order: 'id  desc'
                    }
                });
                dispatch({
                    type: posAction.POS_SETUP_DETAILS_START, url: 'point-of-sales', filter: {
                        order: 'id  desc'
                    }
                });
                dispatchFilter(dateValue, sortBy, sortOrder);
                const checkQZTray = () => {
                    const ws = new WebSocket('ws://localhost:8182'); // Default QZ Tray WebSocket URL
                    ws.onopen = () => {
                        storageSetItem('qzTray', 'installed');
                        ws.close();
                    };
                    ws.onerror = () => {
                        storageSetItem('qzTray', '');
                    };
                };
                checkQZTray();
            }
        }
    }, [roleManagement]);

    useEffect(() => {
        if (posSetupUsers) {
            setTeamList(
                posSetupUsers.map((d) => { return d.user })
            );
        }
    }, [posSetupUsers]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }

        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            //toast(createDetails);
            history.push(`/sales/sales-management/store-sales/${AESEncrypt(form)}/create`);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError?.error?.message.split("|");
            if (error && error[0] === 'password') {
                toast.dismiss();
                toast.error(error[1]);
            }

        }
    }, [createDetails, createError]);

    const dispatchFilter = (dateValue, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (dateValue[0] !== null && dateValue[1] !== null) {
            // filter['and'].push({ transactionDate: { gte: moment(dateValue[0]).subtract(1, "days").format('YYYY-MM-DD') } });
            // filter['and'].push({ transactionDate: { lte: moment(dateValue[1]).add('days', 1).format('YYYY-MM-DD') } });
            filter['and'].push({ transactionDate: { gte: moment(dateValue[0]).format('YYYY-MM-DD') } });
            filter['and'].push({ transactionDate: { lt: moment(dateValue[1]).add('days', 1).format('YYYY-MM-DD') } });

            // filter['and'].push({ transactionDate: { between: [moment(dateValue[0]).format('YYYY-MM-DD'), moment(dateValue[1]).format('YYYY-MM-DD')] } });
        }

        if (search !== '') {
            or['or'].push({ cashReceiptNumber: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customerName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customerEmail: { like: '%' + search.trim() + '%' } });
            or['or'].push({ customerMobile: { like: '%' + search.trim() + '%' } });
            or['or'].push({ billStatus: { like: '%' + search.trim() + '%' } });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'store-sales',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.STORE_SALES_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'store-sales',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(dateValue, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(dateValue, sortBy, sortOrder, s);
    }

    const handleDates = (value, reset = false) => {
        setDateValue(value);
        if ((value[0] !== null && value[1] !== null) || reset) {
            dispatchFilter(value, sortBy, sortOrder);
        }
    }

    const handleNew = (value) => {
        setNewSalesModal(true);
        setForm({
            'type': value
        });
        setTimeout(() => { document.getElementById('Radio-SS-new-sales').focus(); })
    }

    const changeHandler = (e, name) => {
        if (name !== '') {
            let data = {
                ...form,
                [name]: e.id
            }
            if (name === 'userId') {
                data['user'] = e
            }
            setForm(data);
            if (name === 'posId') {
                dispatch({
                    type: posActions.POS_SETUP_USERS_START,
                    url: 'point-of-sale-users',
                    filter: {
                        where: { "posId": e.id },
                    }
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const emptyState = () => {
        setError({});
    }

    const handleSubmit = () => {
        let emptyPos = emptyValidation('POS Name', form?.posId);
        let emptyUser = emptyValidation('User', form?.userId);
        emptyState();

        // Offline (desktop): the server login can't be reached, so skip the password
        // check. Still require a POS and a user who is actually one of this POS's
        // cached team users (teamList is derived from point-of-sale-users) — so an
        // arbitrary/stale userId can never open the till.
        if (isDesktop() && !online) {
            let isPosUser = teamList.some((u) => u && u.id === form?.userId);
            if (emptyPos.isValid && emptyUser.isValid && isPosUser) {
                history.push(`/sales/sales-management/store-sales/${AESEncrypt(form)}/create`);
            } else {
                setError({
                    posId: emptyPos?.errors,
                    userId: emptyUser?.errors || (isPosUser ? undefined : 'Select a valid POS user'),
                });
            }
            return;
        }

        let emptyPassword = emptyValidation('Password', form?.password);
        if (emptyPos.isValid && emptyUser.isValid && emptyPassword.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: "user/login/null",
                title: "Login",
                details: { email: form?.user?.email, password: form?.password }
            });
            //history.push(`/sales/sales-management/store-sales/${AESEncrypt(form)}/create`);
        } else {
            setError({
                posId: emptyPos?.errors,
                userId: emptyUser?.errors,
                password: emptyPassword?.errors,
            })
        }
    }

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) { //ALT + N
            e.preventDefault();
            handleNew('Sale');
        }
    };

    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                dispatchFilter(dateValue, sortBy, sortOrder);
            }, 500);
        }
    }, [search]);

    const classes = customStyles();
    return (
        <>
            <MainHeader
                {...props}
                img={SettingsImg}
                closeLink={'/sales'}
                title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Store Sales', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={`Store Sales`}
                    component={
                        <>
                            <TopBar
                                dateValue={dateValue}
                                search={search}
                                sortOrder={sortOrder}
                                handleSearch={(value) => setSearch(value)}
                                sortBy={sortBy}
                                handleDates={(value, reset) => handleDates(value, reset)}
                                loadImportExportData={() => loadImportExportData('Store Sales')}
                                roleManagement={roleManagement}
                                checkCRUDPermission={checkCRUDPermission}
                                checkComponentPermission={checkComponentPermission}
                                handleNew={(value) => handleNew(value)}
                            />
                            <CustomTable
                                details={getList}
                                heads={StoreSalesHead}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                                loadMore={loadMore}
                                sortBy={sortBy}
                                sortOrder={sortOrder}
                                roleManagement={roleManagement}
                                loadTasks={() => dispatchFilter(dateValue, sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <CustomModal
                onClose={(v) => { setForm({ type: 'Sale' }); setError({}); setNewSalesModal(v) }}
                yesButton={'OK'}
                noButton={'Cancel'}
                title={'POS Sales'}
                visible={newSalesModal}
                onOpen={() => handleSubmit()}
                loading={createLoader}
                yesId={idNamingConversion('OK', 'storeSales', 'Button')}
                noId={idNamingConversion('Cancel', 'storeSales', 'Button')}
                text={
                    <PosForm
                        customObject={(details, id) => customObject(details, id)}
                        changeHandler={(e, name = '') => changeHandler(e, name)}
                        error={error}
                        posSetup={posSetup}
                        getTeamList={teamList}
                        form={form}
                        online={online}
                        handleSubmit={() => handleSubmit()}
                        roleManagement={roleManagement}
                        checkComponentPermission={checkComponentPermission}
                    />
                }
            />
        </>
    )
}

export default StoreSales;